<div class="form-group" [class.focused] = "selectedReason">
    <select class="select-form-control" [id]="reasonId"
        [(ngModel)]="selectedReason"
        [class.form-error] = "hasError"
        value="" (change)= "sendParentNotification($event)"
        (focus)="selectFirst()">
        <option style="direction: ltr;" *ngFor="let reason of reasonList;let i= index" [ngValue]="reason">
            <span>{{reason.reasonTitle}}</span>
        </option>
    </select>
    <span class="floating-label">بابت</span>
    <span class="star">*</span>
    <span *ngIf="hasError" class="errorInput">پر کردن این فیلد الزامی است.</span>
</div>
